import styled from 'styled-components';

export const Container = styled.div`
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 18px;
`;
